var $ = jQuery.noConflict();

// ==========================================
// JUDGEME CAROUSEL - Inject product thumbnail into no-media review cards
// For cards with class jm-carousel-review-item--no-media, clone the img
// from .jm-product-variant-card__thumbnail and prepend into .jm-carousel-review-item__body
// ==========================================
function setShopifyImageWidth(source, width) {
    if (!source) return '';

    try {
        var imageUrl = new URL(source, window.location.href);
        // Do not treat lazy-loading placeholders as a usable product photo.
        if (!/^https?:$/.test(imageUrl.protocol)) return '';
        imageUrl.searchParams.set('width', width);
        return imageUrl.toString();
    } catch (error) {
        return '';
    }
}

function getReviewThumbnailSource($img) {
    // Prefer real lazy-load sources over a placeholder src.
    var attributes = ['data-src', 'data-srcset', 'src', 'srcset'];
    for (var i = 0; i < attributes.length; i++) {
        var source = ($img.attr(attributes[i]) || '').trim();
        if (attributes[i].indexOf('srcset') !== -1) {
            source = source.split(',')[0].trim().split(/\s+/)[0];
        }
        var normalized = setShopifyImageWidth(source, 720);
        if (normalized) return normalized;
    }
    return '';
}

function updateReviewThumbnailImage($img, source, widthElement) {
    var img = $img[0];
    if (!img) return false;
    source = source || getReviewThumbnailSource($img);
    var src = setShopifyImageWidth(source, 720);
    if (!src) return false;

    var frame = widthElement || img.parentElement;
    var displayWidth = frame ? Math.ceil(frame.getBoundingClientRect().width) : 0;
    // The review cards are capped at 380px wide; use that when layout is not measurable yet.
    displayWidth = displayWidth > 0 ? Math.min(displayWidth, 380) : 380;

    var srcset = [displayWidth, displayWidth * 2, displayWidth * 3].map(function(width) {
        return setShopifyImageWidth(source, width) + ' ' + width + 'w';
    }).join(', ');

    // Own lazy loading on the clone so a theme loader cannot restore the old tiny srcset.
    $img.removeAttr('data-src data-srcset data-sizes data-widths data-aspectratio');
    $img.removeClass('lazyload lazyloading lazyautosizes lazy');
    var attributes = {
        loading: 'lazy',
        decoding: 'async',
        fetchpriority: 'low',
        sizes: displayWidth + 'px',
        srcset: srcset,
        src: src
    };
    Object.keys(attributes).forEach(function(name) {
        // Avoid triggering additional mutations/loads when nothing changed.
        if ($img.attr(name) !== attributes[name]) $img.attr(name, attributes[name]);
    });
    return true;
}

function injectProductThumbnailIntoNoMediaCards(container) {
    var $root = container ? $(container) : $('#judgeme_product_reviews');
    if ($root.length === 0) return;

    $root.find('.jm-carousel-review-item--no-media').each(function() {
        var $card = $(this);

        var $body = $card.find('.jm-carousel-review-item__body').first();
        if ($body.length === 0) return;

        var $selectedThumb = $();
        var $sourceImg = $();
        var source = '';

        // A thumbnail wrapper can exist before its image (or URL) is ready.
        var selectors = ['.jm-product-variant-card__thumbnail', '.jm-highlight-thumbnail'];
        for (var i = 0; i < selectors.length && !source; i++) {
            $card.find(selectors[i]).each(function() {
                var $candidate = $(this).find('img').first();
                source = getReviewThumbnailSource($candidate);
                if (!source) return;
                $selectedThumb = $(this);
                $sourceImg = $candidate;
                return false;
            });
        }

        if (!source) {
            $('.productView-image[data-index="1"] img').each(function() {
                var $candidate = $(this);
                source = getReviewThumbnailSource($candidate);
                if (!source) return;
                $sourceImg = $candidate;
                return false;
            });
        }
        // Leave the card eligible for a retry when neither source is available yet.
        if (!source) return;

        var $existingThumb = $body.children('.sg-cloned-product-thumb').first();
        var $existingImg = $existingThumb.find('img').first();
        if ($existingImg.length && getReviewThumbnailSource($existingImg) === source) {
            updateReviewThumbnailImage($existingImg, source, $body[0]);
            return;
        }

        // Only modify the detached clone, never the original card/gallery image.
        var $clonedThumb = $selectedThumb.length ? $selectedThumb.clone() : $('<div>').append(
            $('<img>').attr('alt', $('h1.productView-title').first().text().trim() || $sourceImg.attr('alt') || '')
        );
        var $clonedImg = $clonedThumb.find('img').first();
        $clonedThumb.addClass('sg-cloned-product-thumb');
        $clonedThumb.removeClass('jm-product-variant-card__thumbnail jm-highlight-thumbnail');
        if (!updateReviewThumbnailImage($clonedImg, source, $body[0])) return;

        // Also replace a gallery fallback if the card's own product photo arrives later.
        if ($existingThumb.length) {
            if (sgReviewThumbnailResizeObserver) sgReviewThumbnailResizeObserver.unobserve($existingThumb[0]);
            $existingThumb.remove();
        }
        $body.prepend($clonedThumb);
        if (sgReviewThumbnailResizeObserver) sgReviewThumbnailResizeObserver.observe($clonedThumb[0]);
        if (!$card.hasClass('sg-thumb-injected')) $card.addClass('sg-thumb-injected');
    });
}

// Hidden/late-layout cards and responsive resizes must not keep their initial sizes value.
var sgReviewThumbnailResizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function(entries) {
    entries.forEach(function(entry) {
        if (!entry.target.isConnected) {
            sgReviewThumbnailResizeObserver.unobserve(entry.target);
            return;
        }
        updateReviewThumbnailImage($(entry.target).find('img').first());
    });
}) : null;

// Run immediately if #judgeme_product_reviews already exists
if (document.getElementById('judgeme_product_reviews')) {
    injectProductThumbnailIntoNoMediaCards();
}

// Watch source readiness as well as late widget/card insertion. The gallery fallback
// lives outside the reviews container, so observing only the widget misses its updates.
if (typeof MutationObserver !== 'undefined') {
    var jmCarouselObserver = new MutationObserver(function(mutations) {
        var shouldProcess = mutations.some(function(mutation) {
            var target = mutation.target;
            if (target.nodeType !== 1 || target.closest('.sg-cloned-product-thumb')) return false;
            if (mutation.type === 'attributes') {
                return target.matches('#judgeme_product_reviews, .jm-carousel__track, .jm-carousel-review-item--no-media') ||
                    (target.matches('img') && !!target.closest('.jm-carousel-review-item--no-media, .productView-image[data-index="1"]'));
            }
            return Array.prototype.some.call(mutation.addedNodes, function(node) {
                if (node.nodeType !== 1 || node.matches('.sg-cloned-product-thumb')) return false;
                var selector = '#judgeme_product_reviews, .jm-carousel-review-item, .jm-carousel__track, .jm-carousel, .productView-image[data-index="1"]';
                return node.matches(selector) || !!node.querySelector(selector) ||
                    !!target.closest('.jm-carousel-review-item--no-media, .productView-image[data-index="1"]');
            });
        });

        if (shouldProcess) {
            clearTimeout(window.sgJmCarouselObserverTimer);
            window.sgJmCarouselObserverTimer = setTimeout(function() {
                console.log('[sg-product] JudgeMe carousel observer - injecting product thumbnails');
                injectProductThumbnailIntoNoMediaCards();
                truncateJdgmReviewBodies();
            }, 200);
        }
    });

    jmCarouselObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-widget-name', 'data-impressions-tracked', 'class', 'src', 'srcset', 'data-src', 'data-srcset']
    });
}

// Also run on jdgm.doneSetup and window load as fallback
document.addEventListener('jdgm.doneSetup', function() {
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 300);
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 1000);
});

window.addEventListener('load', function() {
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 500);
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 2000);
});

if (!sgReviewThumbnailResizeObserver) {
    window.addEventListener('resize', function() {
        clearTimeout(window.sgReviewThumbnailResizeTimer);
        window.sgReviewThumbnailResizeTimer = setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 100);
    });
}

// Disconnect observers on page unload to prevent memory leaks
window.addEventListener('beforeunload', function() {
    clearTimeout(window.sgJmCarouselObserverTimer);
    clearTimeout(window.sgReviewThumbnailResizeTimer);
    if (sgReviewThumbnailResizeObserver) sgReviewThumbnailResizeObserver.disconnect();
    if (typeof jmCarouselObserver !== 'undefined') {
        jmCarouselObserver.disconnect();
    }
    if (typeof jdgmObserver !== 'undefined') {
        jdgmObserver.disconnect();
    }
});

// Additional fallback: Use MutationObserver to detect when Judge.me reviews are added
if (typeof MutationObserver !== 'undefined') {
    var jdgmObserver = new MutationObserver(function(mutations) {
        var hasNewReviews = false;
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && (node.classList.contains('jdgm-rev') || node.classList.contains('jdgm-rev-widg'))) {
                            hasNewReviews = true;
                        }
                        if (node.querySelector && node.querySelector('.jdgm-rev')) {
                            hasNewReviews = true;
                        }
                    }
                });
            }
        });
        
        if (hasNewReviews) {
            clearTimeout(window.jdgmObserverTimer);
            window.jdgmObserverTimer = setTimeout(function() {
                console.log('Judge.me MutationObserver detected reviews - processing');
                processJudgeMeReviewsGlobal();
                truncateJdgmReviewBodies();
            }, 300);
        }
    });
    
    // Start observing document body for Judge.me content
    if (document.body) {
        jdgmObserver.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            jdgmObserver.observe(document.body, { childList: true, subtree: true });
        });
    }
}

// Interval-based fallback for Firefox - check periodically for unprocessed reviews
var intervalCheckCount = 0;
var intervalMaxChecks = 20; // Check for 10 seconds max
var jdgmIntervalCheck = setInterval(function() {
    intervalCheckCount++;
    
    // Check if there are unprocessed reviews
    var $unprocessedReviews = $('.jdgm-rev').filter(function() {
        return !$(this).find('.jdgm-rev__media.sg-processed').length && 
               $(this).find('.jdgm-rev__media').length > 0;
    });
    
    if ($unprocessedReviews.length > 0) {
        console.log('Judge.me interval check found unprocessed reviews - processing');
        processJudgeMeReviewsGlobal();
    }
    
    // Stop checking after max attempts or if all are processed
    if (intervalCheckCount >= intervalMaxChecks || $unprocessedReviews.length === 0) {
        clearInterval(jdgmIntervalCheck);
    }
}, 500);

// Global processing function that can be called from multiple paths
function processJudgeMeReviewsGlobal() {
    $('.jdgm-rev').each(function() {
        var $review = $(this);
        var $media = $review.find('.jdgm-rev__media');
        var $header = $review.find('.jdgm-rev__header');
        
        // Hide the media container with inline style
        if ($media.length > 0 && !$media.hasClass('sg-processed')) {
            $media.attr('style', 'display: none !important');
            $media.addClass('sg-processed');
        }
        
        // Check if cloned image already exists as DIRECT child
        var $existingClone = $review.children('.cloned-review-image');
        if ($existingClone.length > 0) {
            return;
        }
        
        // Remove any misplaced clones
        $review.find('.jdgm-rev__media .cloned-review-image').remove();
        
        // Find the first pic link in media container
        var $firstPicLink = $media.find('a.jdgm-rev__pic-link').first();
        
        if ($firstPicLink.length > 0 && $header.length > 0) {
            var $clonedPicLink = $firstPicLink.clone();
            $clonedPicLink.addClass('cloned-review-image');
            $clonedPicLink.removeClass('jdgm--loading');
            $clonedPicLink.find('img').each(function() {
                var $img = $(this);
                var currentSrc = $img.attr('src');
                var currentDataSrc = $img.attr('data-src');
                
                // Determine the best source URL (prefer data-src for lazy loaded images)
                var imageUrl = currentDataSrc || currentSrc;
                
                if (imageUrl) {
                    // Update to higher resolution
                    imageUrl = imageUrl.replace('w=160', 'w=600');
                    
                    // Always set both src and data-src to ensure image loads
                    $img.attr('src', imageUrl);
                    $img.attr('data-src', imageUrl);
                    
                    // Remove lazy loading class if present
                    $img.removeClass('lazyload lazy');
                }
            });
            $header.before($clonedPicLink);
        }
    });
    
    // Also add rating value if not present
    var $summary = $('#judgeme_product_reviews .jdgm-rev-widg__summary');
    if ($summary.length > 0) {
        var summaryText = $summary.text().trim();
        var ratingMatch = summaryText.match(/^(\d+\.?\d*)/);
        if (ratingMatch) {
            var rating = ratingMatch[1];
            var $summaryInner = $summary.closest('.jdgm-rev-widg').find('.jdgm-rev-widg__summary-inner');
            if ($summaryInner.length > 0 && !$summaryInner.find('.rating-value').length) {
                $summaryInner.prepend('<span class="rating-value">' + rating + '</span>');
            }
        }
    }
}

// ==========================================
// JDGM REVIEW BODY TRUNCATION
// If .jdgm-review-content__body-content has > 23 words, truncate and add expand button
// ==========================================
function truncateJdgmReviewBodies(root) {
    var $root = root ? $(root) : $(document);
    $root.find('.jdgm-review-content__body-content').each(function() {
        var $el = $(this);

        // Skip if already processed
        if ($el.hasClass('sg-truncated')) return;

        var fullText = $el.text().trim();
        var words = fullText.split(/\s+/);
        if (words.length <= 22) return;

        // Store full text for expansion
        $el.attr('data-full-text', fullText);

        var truncated = words.slice(0, 22).join(' ') + '…';
        $el.text(truncated);
        $el.addClass('sg-truncated');

        var $btn = $(
            '<button class="jm-review-content__expand-button" type="button" aria-expanded="false">' +
            '<p class="jm-text" style="--text-size: var(--jm-body-md-size); --text-weight: var(--jm-body-md-weight-bold);">More</p>' +
            '</button>'
        );

        // Insert button after .jm-review-body-wrapper (parent wrapper), not after $el
        var $wrapper = $el.closest('.jm-review-body-wrapper');
        var $insertAfter = $wrapper.length ? $wrapper : $el;

        // Only insert button if one doesn't already exist after the target
        if ($insertAfter.next('.jm-review-content__expand-button').length > 0) return;

        $insertAfter.after($btn);

        $btn.on('click', function() {
            var expanded = $(this).attr('aria-expanded') === 'true';
            if (expanded) {
                $el.text(words.slice(0, 22).join(' ') + '…');
                $(this).attr('aria-expanded', 'false');
                $(this).find('.jm-text').text('More');
            } else {
                $el.text($el.attr('data-full-text'));
                $(this).attr('aria-expanded', 'true');
                $(this).find('.jm-text').text('Less');
            }
        });
    });
}

// Fallback truncation for initial load (MutationObservers handle dynamic content)
document.addEventListener('jdgm.doneSetup', function() {
    setTimeout(function() { truncateJdgmReviewBodies(); }, 400);
});

window.addEventListener('load', function() {
    setTimeout(function() { truncateJdgmReviewBodies(); }, 600);
});
